export default function DepartmentProceduresDirective() {
  return {
    template: require('./department-procedures.html'),
    scope: {
      assessmentId: '=',
      status: '@',
      canEdit: '<',
    },
    controller: 'DepartmentProceduresController',
    controllerAs: 'departmentProceduresVM',
    bindToController: true,
    replace: true,
  };
}
